function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#D13D9E"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.06396,
  y: 3.06384,
  width: 41.8723,
  height: 41.8723,
  rx: 20.9362,
  fill: "#D13D9E"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.14893 24C7.14893 14.6934 14.6934 7.14893 24 7.14893C33.3066 7.14893 40.8511 14.6934 40.8511 24C40.8511 33.3066 33.3066 40.8511 24 40.8511C14.6934 40.8511 7.14893 33.3066 7.14893 24Z",
  fill: "#D13D9E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2968 24.1919L26.7915 22.5975C26.6306 22.4951 26.4413 22.2332 26.3944 22.0482L25.7007 19.3044C25.7002 19.3028 25.6995 19.3012 25.6991 19.2996C25.6419 18.9806 25.3639 18.7374 25.0285 18.7374H21.654C21.4997 18.7374 21.3588 18.7906 21.2446 18.8773C21.2209 18.8905 21.1966 18.9032 21.1752 18.9183L18.7741 20.629C18.4999 20.8242 18.3338 21.2365 18.3957 21.5676L19.1394 25.5401C19.2031 25.8812 19.5262 26.1483 19.875 26.1483L20.2568 26.1278C20.4407 26.1174 20.6095 26.0318 20.7206 25.8926C20.8314 25.7535 20.8776 25.5697 20.8469 25.3883L20.3281 22.3244C20.3007 22.1635 20.3977 21.9317 20.531 21.8379L20.9716 21.528V26.0209C20.9661 26.0361 20.9581 26.05 20.9531 26.0655L18.727 33.0371C18.6344 33.3274 18.6626 33.633 18.8067 33.8974C18.9507 34.1618 19.1921 34.3511 19.4864 34.4305L19.6352 34.4708C19.7326 34.4972 19.8336 34.5106 19.9351 34.5106C20.4473 34.5106 20.9126 34.1737 21.0669 33.6908L23.1803 27.0722H23.3558L23.7412 28.9883C23.8025 29.2919 23.8598 29.8102 23.8669 30.1199L23.9538 34.0344C23.9631 34.4554 24.2842 34.7728 24.7006 34.7728C24.737 34.7728 24.7741 34.7703 24.8116 34.765L25.545 34.6633C25.9821 34.6026 26.3191 34.1946 26.2961 33.7538L26.0907 29.8236C26.0736 29.4932 26.0226 28.9567 25.9773 28.6274L25.6911 26.5461C25.7032 26.4956 25.7109 26.4434 25.7109 26.3893V24.1222L28.4048 25.6732C28.5086 25.7328 28.6269 25.7644 28.7473 25.7644C28.9903 25.7644 29.2183 25.6363 29.3423 25.4302L29.5193 25.1355C29.7114 24.8154 29.6115 24.3921 29.2968 24.1919Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1139 18.159C24.4735 18.159 25.5796 17.0529 25.5796 15.6933C25.5796 14.3337 24.4735 13.2276 23.1139 13.2276C21.7543 13.2276 20.6484 14.3337 20.6484 15.6933C20.6484 17.0529 21.7543 18.159 23.1139 18.159Z",
  fill: "white"
});

function SvgIconWalkingActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalkingActive);
export default __webpack_public_path__ + "static/media/icon_walking_active.b806e305.svg";
export { ForwardRef as ReactComponent };